module.exports = __webpack_public_path__ + "static/media/and_scr_onboarding_02_b.5ab26ae4.png";